import script from "./OverallValidationBooleanDisplay.vue?vue&type=script&setup=true&lang=ts"
export * from "./OverallValidationBooleanDisplay.vue?vue&type=script&setup=true&lang=ts"

import "./OverallValidationBooleanDisplay.vue?vue&type=style&index=0&id=4524a200&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4524a200"]])

export default __exports__